import React, { FC } from 'react';
import { MilestoneStatusCode } from '@bechtel/types';
import { Box, SetDirection, Set, SetSpacing, Text } from '@bechtel/gds';
import { MilestoneHoursProps } from './types';
import { MilestoneStatusExt, MilestoneStatusExtended } from '../types';
import { bankersRound } from '@bechtel/client-common';
import { t } from '@lingui/macro';

const getHoursLabel = (status: MilestoneStatusExt, isFitupMilestone?: boolean, hasFitupRequest?: boolean) => {
  if (isFitupMilestone) return t`Fitup Hours`;

  switch (status) {
    case MilestoneStatusCode.REQUESTED:
      return t`Fitup Hours`;
    case MilestoneStatusCode.PLANNED:
    default:
      return t`Hours to Earn`;
    case MilestoneStatusCode.CLAIMED:
      return hasFitupRequest ? t`Hours Until Claim` : t`Hours Claimed`;
    case MilestoneStatusCode.REJECTED:
      return t`Hours Rejected`;
    case MilestoneStatusCode.APPROVED:
      return hasFitupRequest ? t`Hours Until Approve` : t`Hours Approved`;
    case MilestoneStatusExtended.BLOCKED:
      return t`Hours Blocked`;
  }
};

export const MilestoneHours: FC<MilestoneHoursProps> = ({ hours, status, isFitupMilestone, hasFitupRequest }) => {
  return (
    <Box flexDirection={{ sm: 'column' }} py={{ sm: '500' }}>
      <Set
        style={{ whiteSpace: 'nowrap' }}
        spacing={SetSpacing.COMPACT}
        direction={SetDirection.COL}
        alignItems={'center'}
      >
        <Text size="800" color="grey.1000">
          {isFitupMilestone ? '-' : bankersRound(hours, 0)}
        </Text>

        <Text size="300" color="grey.600">
          {getHoursLabel(status, isFitupMilestone, hasFitupRequest)}
        </Text>
      </Set>
    </Box>
  );
};
